import { useT } from '@eturi/react-i18next'
import { useCallback } from 'react'

export const useBirthdayDisplayAge = () => {
	const [t] = useT('child_profile.edit.age_labels')

	return useCallback(
		(age: number) => {
			let labelKey = 'default'

			if (age === 0) labelKey = 'zero'
			if (age === 1) labelKey = 'one'
			if (age === 18) labelKey = 'eighteen_plus'

			return t(labelKey, { age })
		},
		[t],
	)
}
